import Http from "../helpers/Http";

class InventoryService {

  get() {
    return Http.get('/inventory');
  }

  create(data) {
    return Http.post("/inventory",data);
  }

  update(data) {
    return Http.update("/packages",data);
  }

  search(data) {
    return Http.post("/packages/updateByTracking",data);
  }

  searchByTracking(data) {
    return Http.post("/packages/getByTracking",data);
  }

  changePkgStatus(data) {
    return Http.post("/inventory/changePkgStatus",data);
  }

  changePkgStatusByTracking(data) {
    return Http.post("/packages/updateStatusByTracking",data);
  }

  addUser(data) {
    return Http.post("/inventory/setCustomer",data);
  }
  
  getLocations () {
    return Http.post('/inventory/ubications ');
  }
  
  getOrders  () {
    return Http.get('/dispatch ');
  }

  getInventory (data) {
    return Http.post('/inventory/list', data);
  }

  newDispatch(data){
    return Http.post('/dispatch', data);
  }

  getPacksDispatch(data){
    return Http.post('/dispatch/packages', data);
  }

  getDispatchDetail(id){
    return Http.get('/dispatch/' + id);
  }

  getInventoryDetail(id){
    
    return Http.get('/inventory/' + id);

  }

  getStatusDispatch(){
    return Http.get('/status/dispatch');
  }

  changeStatusDispatch(data){
    return Http.post('/dispatch/changeStatus', data);
  }

  downloadOrdersToProvider(data){
    return Http.downloadFiles("/dispatch/reportPks",data);
  }

  sendReportByEmail( data ){
    return Http.post('/dispatch/reportPksMail', data);
  }

  updateInventory(id, data){
    delete data.id
    return Http.update('/inventory/' + id, data)
  }

  deleteInventory(id){
    return Http.delete('/inventory/' + id)
  }


}

export default new InventoryService();